
import Vue from 'vue'
import AppBar from '@/components/AppBar.vue'
import Footer from '@/components/Footer.vue'
import CookieConsent from '@/components/CookieConsent.vue'
import BottomNavigation from '@/components/BottomNavigation.vue'
import ParentConsentPopup from '@/components/ParentConsentPopup.vue'
import Surveys from '@/components/Surveys.vue'
import VueMoment from 'vue-moment'
import SmoothScrollbar from 'vue-smooth-scrollbar'

Vue.use(VueMoment)
Vue.use(SmoothScrollbar)

export default Vue.extend({
  name: 'App',

  components: {
    AppBar,
    Footer,
    CookieConsent,
    BottomNavigation,
    ParentConsentPopup,
    Surveys,
  },

  computed: {
    alertMessage() {
      return this.$store.state.alert.message
    },
    alertType() {
      return this.$store.state.alert.type
    },
  },
  async mounted() {
    await this.$recaptchaLoaded()
    this.$recaptchaInstance.hideBadge()
  },
  data: () => ({
    bottomNavigation: false,
    mainNavigation: [
      { title: 'Projects', to: '/projects' },
      { title: 'Contests', to: '/contests/open' },
      { title: 'News', to: '/news' },
      { title: 'Learn', to: '/learn' },
      { title: 'About Us', to: '/about-us' },
      { title: 'Contact', to: '/contact' },
    ],
  }),
})
